import { UserAccountApi, useAPIAction } from "melco-shared-logic";
import { useCallback } from "react";

export const useDeleteNotifications = () => {
  const [deleteNotification] = useAPIAction(
    UserAccountApi,
    async (api, id: string) => {
      const data = await api.userProductNotificationsDelete({
        id,
        productCode: process.env.REACT_APP_PRODUCT_CODE!,
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "notifications.actions.delete",
    }
  );

  return useCallback(
    async (notificationIds: string[]) => {
      const successfullyDeleted: string[] = [];

      for (const notificationId of notificationIds) {
        try {
          await deleteNotification(notificationId);
          successfullyDeleted.push(notificationId);
        } catch (e) {
          // error handling is already done in useAPIAction
        }
      }

      return successfullyDeleted;
    },
    [deleteNotification]
  );
};
